export const getEdits = (project) => {
    return new Promise(async (resolve, reject) => {
        console.log("getting edits for project=", project);
        let query = {project}
        fetch('/projectEdits/' , {
            method: 'POST',
            body: JSON.stringify(query),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                resolve(resp);
            });
    });
};
